import React, { memo, useState } from "react";
import NumberFormat from "react-number-format";
import { TextField } from "@material-ui/core"; 

const TimeFormat = (props) => {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        })
      }}
      isNumericString
      format="##:##"
      mask={['H', 'H', 'm', 'm']} />
  );
}

const TimeInput = ({ defaultValue, onChange }) => {

  const [ value, setValue ] = useState(defaultValue);

  const handleChange = evt => {
    setValue(evt.target.value);
  }

  const handleBlur = () => {
    if (value !== defaultValue) {
      onChange(value);
    }
  }

  return (
    <TextField
      label=""
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      InputProps={{
        inputComponent: TimeFormat
      }}
      InputLabelProps={{shrink: false}} />
  );
}

export default TimeInput;